import React from 'react';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { ConnectedSpaceInfoProvider } from '~src/spacesPlatform/components/Explorer/helpers/SpaceInfoProvider';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import { ConnectedQueryParamUpdateProvider } from '../../../../bootstrap/routerHelpers/QueryParamUpdateProvider';
import { ConnectedAllServerUsersSpace } from './ConnectedAllServerUsersSpace';

export interface AllServerUsersSpaceProviderProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
}

interface AllServerUsersSectionProviderProps extends AllServerUsersSpaceProviderProps {
}

const AllServerUsersSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'serverusers',
  subspaceName: undefined,
  isKeysetPaginationSpace: FeatureFlags.serverUserSolrMigrationEnabled
};

const AllServerUsersSectionProvider: React.FunctionComponent<AllServerUsersSectionProviderProps> = (props) => {
  let spaceInfo: SpaceInfo = {...AllServerUsersSpaceInfo, isKeysetPaginationSpace: FeatureFlags.serverUserSolrMigrationEnabled};
  return (
    <ConnectedSpaceInfoProvider spaceInfo={spaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={true}
        shouldUpdateContentTypes={false}
        shouldUpdateFilters={true}
        shouldUpdateSort={true}
      >
        <ConnectedAllServerUsersSpace shouldRenderAsSubspace={false}/>
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};

export const AllServerUsersSpaceProvider: React.FunctionComponent<AllServerUsersSpaceProviderProps> = (props) => {
  return <AllServerUsersSectionProvider {...props}/>;
};
